export default "__VITE_ASSET__BY2iH1Hv__"